import Vue from 'vue';
//import { Config } from '@/models/ViewportConfig';
import Component from 'vue-class-component';
import { ProductSection, Product } from '../../models/ProductModels';
import { Viewport } from '../../models/Viewport';
//import { getProductUrl } from '../../models/UtilService';


@Component({
    name: 'product-link-softbook',
    props: {
        prodid: {

        },
        viewport: {

        }
    }
})

export default class ProductLinkSoftbook extends Vue {
    prodid: string;
    viewport: Viewport;
    public prod: Product;

    /*
    get getProductUrl(): string {

        let returnValue: string = 'undefined URL';
        if (!this.prod)
            return `http://The product with Id: ${this.prodid} not found`;
        else if (!this.prod.latestVersion)
            return `http://Latest version of Product with Id: ${this.prodid} not found`;
        else
            return this.prod.latestVersion.spaceUrl?`/SoftbooksIndex.html#/product/${this.prod.latestVersion.spaceKey}`:process.env.VUE_APP_SERVER_BASE_ADRESS+'/index/error';
        //  console.log("ALL-LINKS: ", returnValue);
    }
*/

    routerLink(){
        return `${this.$i18n.locale}/product/${this.prod.latestVersion.spaceKey}`;
    }

    created() {
        this.prod = this.viewport.utilserv.productStructur.
            products[this.prodid];
    }
}


